// dev-requests-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Algo novo no sistema.": "Algo nuevo en el sistema.",
    "Algo que deveria funcionar e não funciona.": "Algo que debería funcionar y no funciona.",
    "Como pedir uma mudança, uma investigação ou uma tarefa ao desenvolvimento: escrever bem o pedido, urgente ou normal, responder dúvidas e fechar.": "Cómo pedir un cambio, una investigación o una tarea al desarrollo: escribir bien el pedido, urgente o normal, responder dudas y cerrar.",
    "Outra demanda, como alterar dados no banco. Mudança de dado passa pela aprovação do desenvolvedor.": "Otra demanda, como cambiar datos en la base. Un cambio de datos pasa por la aprobación del desarrollador.",
    "Só descobrir o que aconteceu, sem mudar nada.": "Solo descubrir qué pasó, sin cambiar nada.",
    "Tarefa": "Tarea",
};

export default catalogo;
